const quote = [{
  desc: '注册认证列表',
  options: {
    url: '/regAuth/queryRegAuthList',
    method: 'post'
  }
}, {
  desc: '注册认证列表(新)',
  options: {
    url: '/regAuth/queryRegAuthListNew',
    method: 'post'
  }
}, {
  desc: '注册认证列表(新)',
  options: {
    url: '/regAuth/queryRegAuthDetailNew',
    method: 'post'
  }
}, {
  desc: '删除注册人员(待入职)',
  options: {
    url: '/regAuth/deleteRegAuthSale',
    method: 'post',
    argsParams: true
  }
}, {
  desc: '离职审批列表',
  options: {
    url: '/sysSalesResign/queryPage',
    method: 'post'
  }
}, {
  desc: '人员用工合同信息列表',
  options: {
    url: '/salesContract/queryPage',
    method: 'post'
  }
}, {
  desc: '获取在职销售人员',
  options: {
    url: '/sysSales/querySalesOnJod',
    method: 'post'
  }
}, {
  desc: '人员用工合同信息签约',
  options: {
    url: '/salesContract/signup',
    method: 'post'
  }
}, {
  desc: '人员用工合同信息续约',
  options: {
    url: '/salesContract/renew',
    method: 'post'
  }
}, {
  desc: '解约恢复申请人员',
  options: {
    url: '/sysSalesResign/resignResumeDetail',
    method: 'post'
  }
}, {
  desc: '人员用工职业等级登记列表',
  options: {
    url: '/salesPracticeRegist/queryPage',
    method: 'post'
  }
}, {
  desc: '解约恢复申请',
  options: {
    url: '/sysSalesResign/saveResignResume',
    method: 'post'
  }
}, {
  desc: '人员用工合同信息解约',
  options: {
    url: '/salesContract/termination',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '注册认证审批',
  options: {
    url: '/regAuth/regAuthApproval',
    method: 'post'
  }
}, {
  desc: '注册认证审批（新）',
  options: {
    url: '/regAuth/regAuthApprovalNew',
    method: 'post'
  }
}, {
  desc: '根据车险organizationId 获取合规组织信息',
  options: {
    url: '/sysBranchOrg/branchOrgDetails',
    method: 'post'
  }
}, {
  desc: '生成工号',
  options: {
    url: '/sysSales/generatePersonCode',
    method: 'post'
  }
}, {
  desc: '获取字段是否隐藏',
  options: {
    url: '/sysSales/getRegulatoryHide',
    method: 'get'
  }
}, {
  desc: '获取在职销售人员',
  options: {
    url: '/channelPost/cx',
    method: 'get',
    baseURL: '/sxcore/api',
    argsParams: true
  }
}, {
  desc: '获取销售人员',
  options: {
    url: '/sysSales/queryPage',
    method: 'post'
  }
}, {
  desc: '推荐关系修改轨迹列表',
  options: {
    url: '/sysSales/queryRecommendModifytrack',
    method: 'post'
  }
}, {
  desc: '推荐人异动轨迹导出',
  options: {
    url: '/sysSales/exportRecommendModify',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '新版人管人员离司申请',
  options: {
    url: '/sysSales/salesResignApproval',
    method: 'post'
  }
}, {
  desc: '人员用工职业登记上编',
  options: {
    url: '/salesPracticeRegist/regist',
    method: 'post'
  }
}, {
  desc: '入职新增编辑',
  options: {
    url: '/sysSales/salesSaveOrUpdate',
    method: 'post'
  }
}, {
  desc: '获取人管商户下的所有组织和所属机构信息',
  options: {
    url: '/sysBranchOrg/queryOrganizationInfoByPartner',
    method: 'post'
  }
}, {
  desc: '获取二次入司人员',
  options: {
    url: '/salesRejoin/queryPage',
    method: 'post'
  }
}, {
  desc: '解约恢复申请新增编辑',
  options: {
    url: '/sysSalesResign/saveResignResume',
    method: 'post'
  }
}, {
  desc: '二次入司详情',
  options: {
    url: '/salesRejoin/salesRejoinDetail',
    method: 'post'
  }
}, {
  desc: '信息修改轨迹列表',
  options: {
    url: '/sysSales/querySalesModifytrack',
    method: 'post'
  }
}, {
  desc: '信息维护列表',
  options: {
    url: '/sysSales/salesInfoList',
    method: 'post'
  }
}, {
  desc: '人员列表',
  options: {
    url: '/sysSales/querySalesInfoList',
    method: 'post'
  }
}, {
  desc: '自定义模板列表',
  options: {
    url: '/templateConfig',
    method: 'get'
  }
}, {
  desc: '新增自定义模板',
  options: {
    url: '/templateConfig/add',
    method: 'post'
  }
}, {
  desc: '查询指定导出类型的字段配置',
  options: {
    url: '/templateConfig/fieldConfig',
    method: 'get'
  }
}, {
  desc: '查询已启用的所有模板',
  options: {
    url: '/templateConfig/templates',
    method: 'get'
  }
}, {
  desc: '更新自定义模板',
  options: {
    url: '/templateConfig/update',
    method: 'post'
  }
}, {
  desc: '入职管理审批',
  options: {
    url: '/sysSales/salesApproval',
    method: 'post'
  }
}, {
  desc: '推广员审批（新）',
  options: {
    url: '/sysSales/promotionApprovalNew',
    method: 'post'
  }
}, {
  desc: '人员影像件下载',
  options: {
    url: '/sysSales/salesDirectDown',
    method: 'get',
    argsParams: true,
    responseType: 'arraybuffer'
  }
}, {
  desc: '通过id获取详情审批信息',
  options: {
    url: '/sysSales/querySalesInfoById',
    method: 'post'
  }
}, {
  desc: '根据车险人员id获取人管销售人员详情',
  options: {
    url: '/sysSales/querySalesInfoByCustomerId',
    method: 'post'
  }
}, {
  desc: '改版人管人员、用户融合新增编辑',
  options: {
    url: '/sysSales/salesSpecialOperation',
    method: 'post'
  }
}, {
  desc: '人员信息维护特殊操作',
  options: {
    url: '/sysSales/salesSaveOrUpdateNew',
    method: 'post'
  }
}, {
  desc: '二次入司审批',
  options: {
    url: '/salesRejoin/rejoinApproval',
    method: 'post'
  }
}, {
  desc: '离职审批',
  options: {
    url: '/sysSalesResign/resignApproval',
    method: 'post'
  }
}, {
  desc: '人员用工合同影像上传',
  options: {
    url: '/salesContract/uploadFile',
    method: 'post'
  }
}, /* {
  desc: '批量导入人员任务文件',
  options: {
    url: '/upload/uploadSalesInfoFile',
    method: 'post'
  }
}, */ {
  desc: '查看审批记录',
  options: {
    url: '/sysSales/querySalesApproval',
    method: 'post'
  }
}, {
  desc: '信息维护列表导出',
  options: {
    url: '/sysSales/querySalesInfoForExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '人员用工职业登记注销',
  options: {
    url: '/salesPracticeRegist/cancelRegist',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '离职管理新增编辑',
  options: {
    url: '/sysSalesResign/saveOrUpdateSalesResign',
    method: 'post'
  }
}, {
  desc: '人员用工合同信息续约-可续约人员下拉选择',
  options: {
    url: '/salesContract/queryAllowRenewSales',
    method: 'get'
  }
}, {
  desc: '人管新增人员组织获取',
  options: {
    url: '/sysBranchOrg/queryBranchAndOrgInfoByPartner',
    method: 'post'
  }
}, {
  desc: '条件查询合同模版',
  options: {
    url: '/salesContract/queryPageContractDocuments',
    method: 'post'
  }
}, /* , {
  desc: '文件上传',
  options: {
    url: '/upload/uploadSalesImageFile',
    method: 'post'
  }
} */ {
  desc: '添加合同模版',
  options: {
    url: '/salesContract/addContractDocuments',
    method: 'post'
  }
}, {
  desc: '编辑合同模版',
  options: {
    url: '/salesContract/updateContractDocuments',
    method: 'post'
  }
}, {
  desc: '销售合同编号数据批量导入数据',
  options: {
    url: '/salesContract/salesContractNumImport',
    method: 'post'
  }
}, {
  desc: '销售合同编号数据批量导入数据验证',
  options: {
    url: '/salesContract/salesContractNumImportCheckData',
    method: 'post'
  }
}, {
  desc: '删除模板',
  options: {
    url: '/contractTemp',
    method: 'delete',
    argsParams: true
  }
}, {
  desc: '新增合同模板',
  options: {
    url: '/contractTemp/add',
    method: 'post'
  }
}, {
  desc: '合同模板列表',
  options: {
    url: '/contractTemp/list',
    method: 'get'
  }
}, {
  desc: '查询已启用的模板',
  options: {
    url: '/contractTemp/queryContracts',
    method: 'get'
  }
}, {
  desc: '更新模板',
  options: {
    url: '/contractTemp/update',
    method: 'post'
  }
}, {
  desc: '所属基本法字段是否必填',
  options: {
    url: '/sysBranchOrg/getBasicLawIsRequired',
    method: 'get'
  }
}, {
  desc: '查询组织机构层级信息',
  options: {
    url: '/sysBranchOrg/getBranchTeamInfo',
    method: 'post',
    argsParams: true
  }
}, {
  desc: '组织机构列表下拉接口',
  options: {
    url: '/sysBranchOrg/getSysOrgComInfo',
    method: 'post'
  }
}, {
  desc: '获取归属组织机构',
  options: {
    url: '/sysSales/getBranch',
    method: 'post'
  }
}, {
  desc: '新获取职位职级接口',
  options: {
    url: '/sysSales/channelPost',
    method: 'post'
  }
}, {
  desc: '获取机构下的所有用户',
  options: {
    url: '/sysSales/querySalesByOrgId',
    argsParams: true
  }
}, {
  desc: '推荐关系树',
  options: {
    url: '/sysSales/getRelationTree',
    method: 'post'
  }
}, /* , {
  desc: '人管人员导入',
  options: {
    url: '/upload/uploadSalesInfoFile',
    method: 'post'
  }
} */ {
  desc: '人管人员统计',
  options: {
    url: '/sysSales/queryBranchSalesStatistics',
    method: 'post'
  }
}, {
  desc: '人管人员统计导出',
  options: {
    url: '/sysSales/downloadBranchSalesStatistics',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '人管人员统计导出',
  options: {
    url: '/sysSales/getSalesInfoBases',
    method: 'post'
  }
}, {
  desc: '批量异动',
  options: {
    url: '/sysSales/changeSalesInfos',
    method: 'post'
  }
}, {
  desc: '查询认证配置信息',
  options: {
    url: '/authItem/queryConfig',
    method: 'post'
  }
}, {
  desc: '更新认证配置信息',
  options: {
    url: '/authItem/updateConfig',
    method: 'post'
  }
}, {
  desc: '查询工号规则配置',
  options: {
    url: '/salesNumConfig/querySalesNumConfig',
    method: 'post'
  }
}, {
  desc: '更新认证配置信息',
  options: {
    url: '/salesNumConfig/updateSalesNumConfig',
    method: 'post'
  }
}]
export default quote



// WEBPACK FOOTER //
// ./src/api/personnel.js